












































































































































































































































































































































































































































































































































import { Component, Vue, Mixins } from 'vue-property-decorator';

// Mixins
import SubmitClaimMixin from '@/mixins/Claims/SubmitClaim';

// Components
import Welcome from '@/components/Global/Welcome.vue';

@Component({
	name: 'PageSubmitClaim',
	components: {
		Welcome,
	},
})
export default class SubmitClaim extends Mixins(SubmitClaimMixin) {
	private changePolicyNum($event) {
		this.claim.policyNumber = $event.target.value;
	}

	private changeCommSubmittedBy($event) {
		this.claim.preferred_communicationsSubmittedBy = $event.target.value;
	}

	private changeCommCorrespondence($event) {
		this.claim.preferred_communicationsCorrespondence = $event.target.value;
	}

	private preferred_communicationsHCP($event) {
		this.claim.preferred_communicationsHCP = $event.target.value;
	}

	private reported($event) {
		this.claim.reported = $event.target.value;
	}

	private applicable_insurance_coverage($event) {
		this.claim.applicable_insurance_coverage = $event.target.value;
	}
}
